import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchAsyncVendorProducts,
  getAllVendors,
  getVendorProducts,
  getVendorProductsStatus,
} from "../../store/vendorSlice";
import Loader from "../../components/Loader/Loader";
import ProductListVendor from "../../components/ProductListVendor/ProductListVendor";
import { STATUS } from "../../utils/status";
import "./VendorProductsPage.scss";

const VendorProducts = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const vendorProducts = useSelector(getVendorProducts);
  const vendorProductsStatus = useSelector(getVendorProductsStatus);
  const vendors = useSelector(getAllVendors); // Récupérer tous les vendeurs

  useEffect(() => {
    dispatch(fetchAsyncVendorProducts(id)); // Récupérer les produits du vendeur
  }, [dispatch, id]);

  // Trouver le vendeur correspondant à l'ID
  const vendor = vendors.find((v) => v.id === parseInt(id)); // Assurez-vous que l'ID est au bon type

  return (
    <div className="cat-products py-5 bg-whitesmoke">
      <div className="container">
        <div className="cat-products-content">
          <div className="title-md">
            <h3>
              See our products from vendor:{" "}
              <span className="text-capitalize">
                {vendor ? `${vendor.firstname}` : "Unknown Vendor"}
              </span>
            </h3>
          </div>

          {vendorProductsStatus === STATUS.LOADING ? (
            <Loader />
          ) : vendorProducts && vendorProducts.length > 0 ? (
            <ProductListVendor products={vendorProducts} />
          ) : (
            <p className="no-products-message">
              No products found for vendor{" "}
              {vendor ? `${vendor.firstname}` : "Unknown Vendor"}.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorProducts;
